function BannerSlider() {
	this.build();
}

BannerSlider.prototype.build = function(){
	this.slider = $('.banner-slider');
	const slider = this.slider.find('.slider-banner');
	const sliderDots = this.slider.find('.slider-dots');
	const prevBtn = this.slider.find('.prev');
	const nextBtn = this.slider.find('.next');

	slider.slick({
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: false,
		draggable: true,
		dots: false,
		fade: true,
		speed: 1000,
		infinite: true,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	slider.on('afterChange', function (event, slick, currentSlide) {
		sliderDots.find('li').removeClass('current');
		sliderDots.find('li.item-'+currentSlide).addClass('current');
	});

	sliderDots.find('li').on('click', function() {
		slider.slick('slickGoTo', $(this).data('slide'));
	});

	prevBtn.click(function (e) {
		slider.slick('slickPrev');
	});

	nextBtn.click(function (e) {
		slider.slick('slickNext');
	});
};
